

export function GalleryList({Instagram}: {Instagram: string}) {
  return (
    <div className="work-desc">
          <a
            href="https://instagram.com/laestrellapoda/"
            target="_blank"
            className="btn-primary ig"
            id="instagram-btn-short"
          >
            <img src={Instagram} alt="Instagram" className="instagram-icon" />

            Ver más trabajos
          </a>
          <ul className="items-list">
            <li className="item">Contamos con todos los seguros personales y técnicos.</li>
            <li className="item">Capacitaciones constantes del equipo.</li>
            <li className="item">Más de 20 motosierras de distinto tipo.</li>
            <li className="item">Hidroelevador y equipo de trepa profesional importado.</li>
            <li className="item">Equipo de respaldo con excavadoras, palas cargadoras, equipo de limpieza, camiones, hidrogrúa y más.</li>
          </ul>
        </div>
  );
}